<template>
  <div id="paginaPersonaleMinistero">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">

      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Personale Ministero</b-card-title>
              <b-card-text class="mb-0">
                Teatro Coccia
              </b-card-text>
            </div>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id='dropStagioni' ref='dropStagioni' :query='stagioniQuery' :dataSource='stagioniData'
                  :index='stagioniIndex' :fields='stagioniFields' :change='onStagioneChange'
                  placeholder='Seleziona una Stagione'></ejs-dropdownlist>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id='dropSpettacoli' ref='dropSpettacoli' :query='tipoRendQuery'
                  :dataSource='tipoRendData' :index='tipoRendIndex' :fields='tipoRendFields' :enabled='tipoRendEnabled'
                  :change='onTipoRendChange' placeholder='Seleziona la Tipologia'></ejs-dropdownlist>
              </b-col>
              <b-col xl="12" md="12" class="pt-1"></b-col>
              <b-col xl="12" md="12" class="pt-1">

                <!-- Timer Alert -->
                <b-col xl="6" md="12">
                  <b-alert :show="alertADismissCountDown" dismissible variant="warning"
                    @dismissed="alertADismissCountDown = 0" @dismiss-count-down="alertACountDownChanged">
                    <p>Occorre selezionare una riga della tabella</p>
                    <b-progress variant="warning" :max="alertADismissSecs" :value="alertADismissCountDown"
                      height="4px" />
                  </b-alert>
                </b-col>

                <div id="GridParent">
                  <ejs-grid id="gridA" ref="gridA" :dataSource="personaleMinisteroFullData" :allowSorting="true"
                    :toolbarClick="gridAClickHandler" :toolbar="gridA.toolbarOptions" :height="gridA.height"
                    :allowFiltering="true" :filterSettings="gridA.filterOptions" :editSettings="gridA.editOptions"
                    :actionBegin="gridAactionBegin" :actionComplete="gridAactionComplete">
                    <e-columns>
                      <e-column field="id" headerText="ID" :isPrimaryKey="true" width="100"></e-column>
                      <e-column field="persMinPrevCognome" headerText="Nominativo" width="200"></e-column>
                      <e-column field="persMinPrevCodiceINPS" headerText="Codice Inps" width="200"></e-column>
                      <e-column field="persMinPrevTipoRapporto" headerText="Rapporto" width="200"></e-column>
                      <e-column field="persMinPrevDataInizio" headerText="Dal" width="200"></e-column>
                      <e-column field="persMinPrevDataFine" headerText="Al" width="200"></e-column>
                      <e-column field="persMinPrevGiornateLavorative" headerText="Giornate" width="200"></e-column>
                      <e-column field="persMinPrevOneri" headerText="persMinPrevOneri" width="200"></e-column>
                      <e-column field="persMinPrevRetribuzione" headerText="persMinPrevRetribuzione" width="200"></e-column>
                      </e-column>
                      </e-column>
                    </e-columns>
                  </ejs-grid>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

    </b-row>

    <!-- dialogA1: dialogDettaglioScrittura ---------------------------------------------------------------------------------------------------- -->
    <ejs-dialog id="dialogA1" ref="dialogA1" :header="dialogA1.header" :buttons="dialogA1.buttons"
      :visible="dialogA1.visible" :showCloseIcon="dialogA1.showCloseIcon" :close="dialogA1Close" :open="dialogA1Open"
      :zIndex="dialogA1.zIndex" :animationSettings="dialogA1.animationSettings">
      <!-- Content dialog -->
      <b-tabs ref="tabAdialogA1" v-model="dialogA1.tabAdialogA1Index">
        <b-tab title="Personale Ministero Preventivo" @click="tabClicked('dialogA1Tab01')">

          <b-row class="match-height">

            <!-- Card con Elementi Input: Dettaglio Ministero 1 -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Ministero 1</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>

                    <!-- Input di tipo checkbox: personaleMinisteroActiveData.persMinPrevpersMinPrevPersonaleDiTerzi -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="persMinPrevPersonaleDiTerzi" class="h5 mr-1">Personale di Terzi</label>
                        <ejs-checkbox id="persMinPrevPersonaleDiTerzi" v-model="personaleMinisteroActiveData.persMinPrevPersonaleDiTerzi" ref="persMinPrevPersonaleDiTerzi"
                          :checked="personaleMinisteroActiveData.persMinPrevPersonaleDiTerzi" name="persMinPrevPersonaleDiTerzi" />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo: personaleMinisteroActiveData.persMinPrevDenominazione  -->
                    <b-col xl="12" md="12" class="mb-2" v-show="this.personaleMinisteroActiveData.persMinPrevPersonaleDiTerzi">
                      <label for="persMinPrevDenominazione" class="h5">Denominazione</label>
                      <ejs-textbox id="persMinPrevDenominazione" v-model="personaleMinisteroActiveData.persMinPrevDenominazione"
                        floatLabelType="Never" cssClass="" placeholder="Denominazione" showClearButton="true"
                        type="text" autocomplete="false" />
                    </b-col>

                    <!-- Input di tipo checkbox: personaleMinisteroActiveData.persMinPrevPersonaleStraniero -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center" v-show="!this.personaleMinisteroActiveData.persMinPrevPersonaleDiTerzi">
                      <b-row class="m-0">
                        <label for="persMinPrevPersonaleStraniero" class="h5 mr-1">Personale Straniero</label>
                        <ejs-checkbox id="persMinPrevPersonaleStraniero" v-model="personaleMinisteroActiveData.persMinPrevPersonaleStraniero" ref="persMinPrevPersonaleStraniero"
                          :checked="personaleMinisteroActiveData.persMinPrevPersonaleStraniero" name="persMinPrevPersonaleStraniero" />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo: personaleMinisteroActiveData.persMinPrevCodiceFiscale  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevCodiceFiscale" class="h5">Codice Fiscale</label>
                      <ejs-textbox id="persMinPrevCodiceFiscale" v-model="personaleMinisteroActiveData.persMinPrevCodiceFiscale"
                        floatLabelType="Never" cssClass="" placeholder="Codice Fiscale" showClearButton="true"
                        type="text" autocomplete="false" />
                    </b-col>

                    <!-- Input di tipo testo: personaleMinisteroActiveData.persMinPrevPartitaIva  -->
                    <b-col xl="12" md="12" class="mb-2" v-show="this.personaleMinisteroActiveData.persMinPrevPersonaleDiTerzi">
                      <label for="persMinPrevPartitaIva" class="h5">Partita Iva</label>
                      <ejs-textbox id="persMinPrevPartitaIva" v-model="personaleMinisteroActiveData.persMinPrevPartitaIva"
                        floatLabelType="Never" cssClass="" placeholder="Partita Iva" showClearButton="true"
                        type="text" autocomplete="false" />
                    </b-col>

                    <!-- Input di tipo testo: personaleMinisteroActiveData.persMinPrevNome  -->
                    <b-col xl="12" md="12" class="mb-2" v-show="!this.personaleMinisteroActiveData.persMinPrevPersonaleDiTerzi">
                      <label for="persMinPrevNome" class="h5">Nome</label>
                      <ejs-textbox id="persMinPrevNome" v-model="personaleMinisteroActiveData.persMinPrevNome" floatLabelType="Never"
                        cssClass="" placeholder="Nome" showClearButton="true" type="text" autocomplete="false" />
                    </b-col>

                    <!-- Input di tipo testo: personaleMinisteroActiveData.persMinPrevCognome  -->
                    <b-col xl="12" md="12" class="mb-2" v-show="!this.personaleMinisteroActiveData.persMinPrevPersonaleDiTerzi">
                      <label for="persMinPrevCognome" class="h5">Cognome</label>
                      <ejs-textbox id="persMinPrevCognome" v-model="personaleMinisteroActiveData.persMinPrevCognome" floatLabelType="Never"
                        cssClass="" placeholder="Cognome" showClearButton="true" type="text" autocomplete="false" />
                    </b-col>

                    <!-- Input di tipo data: personaleMinisteroActiveData.persMinPrevDataNascita -->
                    <b-col xl="12" md="12" class="mb-2" v-show="!this.personaleMinisteroActiveData.persMinPrevPersonaleDiTerzi">
                      <label for="persMinPrevDataNascita" class="h5">Data di Nascita</label>
                      <ejs-datepicker id="persMinPrevDataNascita" v-model="personaleMinisteroActiveData.persMinPrevDataNascita"
                        :format="settings.formatoData" placeholder="Data di Nascita" />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: personaleMinisteroActiveData.persMinPrevNazionalita  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevNazionalita" class="h5">Nazionalità</label>
                      <ejs-dropdownlist id="persMinPrevNazionalita" v-model="personaleMinisteroActiveData.persMinPrevNazionalita"
                        :dataSource="personaleMinisteroNazionalitaList" :fields="personaleMinisteroNazionalitaFields"
                        placeholder="Nazionalità" />
                    </b-col>


                    <!-- Input di tipo checkbox: personaleMinisteroActiveData.persMinPrevUnder35 -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center" v-show="this.personaleMinisteroActiveData.persMinPrevPersonaleDiTerzi">
                      <b-row class="m-0">
                        <label for="persMinPrevUnder35" class="h5 mr-1">Under 35</label>
                        <ejs-checkbox id="persMinPrevUnder35" v-model="personaleMinisteroActiveData.persMinPrevUnder35" ref="persMinPrevUnder35"
                          :checked="personaleMinisteroActiveData.persMinPrevUnder35" name="persMinPrevUnder35" />
                      </b-row>
                    </b-col>

                    






                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>

            <!-- Card con Elementi Input: Dettaglio Ministero 2 -->
            <b-col xl="6" md="12">
              <b-card tag="article" class="mb-2">
                <b-card-header class="align-items-baseline">
                  <div>
                    <b-card-title>Dettaglio Ministero 2</b-card-title>
                    <b-card-text class="mb-0" />
                  </div>
                </b-card-header>
                <b-card-body class="mb-0">
                  <!-- card body -->
                  <b-row>

                    <!-- Input di tipo dropdown senza azioni: personaleMinisteroActiveData.persMinPrevCodiceINPS  -->
                    <b-col xl="12" md="12" class="mb-2" v-show="!this.personaleMinisteroActiveData.persMinPrevPersonaleDiTerzi">
                      <label for="persMinPrevCodiceINPS" class="h5">Codice INPS</label>
                      <ejs-dropdownlist id="persMinPrevCodiceINPS" v-model="personaleMinisteroActiveData.persMinPrevCodiceINPS"
                        :dataSource="personaleMinisteroINPSList" :fields="personaleMinisteroINPSFields"
                        :allowFiltering='personaleMinisteroINPSAllowFiltering'
                        :filtering='personaleMinisteroINPSFiltering' placeholder="Codice INPS" />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: personaleMinisteroActiveData.persMinPrevTipoPersonale  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevTipoPersonale" class="h5">Tipologia Personale</label>
                      <ejs-dropdownlist id="persMinPrevTipoPersonale" v-model="personaleMinisteroActiveData.persMinPrevTipoPersonale"
                        :dataSource="personaleMinisteroTipoPersonaleList"
                        :fields="personaleMinisteroTipoPersonaleListFields" placeholder="Tipologia Personale" />
                    </b-col>

                    <!-- Input di tipo dropdown senza azioni: personaleMinisteroActiveData.persMinPrevTipoRapporto  -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevTipoRapporto" class="h5">Tipologia Rapporto</label>
                      <ejs-dropdownlist id="persMinPrevTipoRapporto" v-model="personaleMinisteroActiveData.persMinPrevTipoRapporto"
                        :dataSource="personaleMinisteroTipoRapportoList" :fields="personaleMinisteroTipoRapportoFields"
                        placeholder="Tipologia Rapporto" />
                    </b-col>

                    

                    <!-- Input di tipo data: personaleMinisteroActiveData.persMinPrevDataInizio -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevDataInizio" class="h5">Data Inizio</label>
                      <ejs-datepicker id="persMinPrevDataInizio" v-model="personaleMinisteroActiveData.persMinPrevDataInizio"
                        :format="settings.formatoData" placeholder="Data di Inizio" />
                    </b-col>

                    <!-- Input di tipo data: personaleMinisteroActiveData.persMinPrevDataFine -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevDataFine" class="h5">Data Fine</label>
                      <ejs-datepicker id="persMinPrevDataFine" v-model="personaleMinisteroActiveData.persMinPrevDataFine"
                        :format="settings.formatoData" placeholder="Data di Fine" />
                    </b-col>

                    <!-- Input di tipo altezza: personaleMinisteroActiveData.persMinPrevGiornateLavorative -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevGiornateLavorative" class="h5">Giornate Lavorative</label>
                      <ejs-numerictextbox id="persMinPrevGiornateLavorative"
                        v-model="personaleMinisteroActiveData.persMinPrevGiornateLavorative" floatLabelType="Never" cssClass=""
                        format="###" placeholder="Numero Giornate Lavorative" showSpinButton="false"
                        showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo valuta: personaleMinisteroActiveData.persMinPrevOneri -->
                    <b-col xl="12" md="12" class="mb-2">
                      <label for="persMinPrevOneri" class="h5">Oneri</label>
                      <ejs-numerictextbox id="persMinPrevOneri" v-model="personaleMinisteroActiveData.persMinPrevOneri" floatLabelType="Never"
                        cssClass="" format="€ ###" placeholder="Oneri" showSpinButton="false" showClearButton="true" />
                    </b-col>

                    <!-- Input di tipo checkbox: personaleMinisteroActiveData.persMinPrevRetribuzione -->
                    <b-col xl="12" md="12" class="mb-2 align-items-center">
                      <b-row class="m-0">
                        <label for="persMinPrevRetribuzione" class="h5 mr-1">Retribuzione</label>
                        <ejs-checkbox id="persMinPrevRetribuzione" v-model="personaleMinisteroActiveData.persMinPrevRetribuzione" ref="persMinPrevRetribuzione"
                          :checked="personaleMinisteroActiveData.persMinPrevRetribuzione" name="persMinPrevRetribuzione" />
                      </b-row>
                    </b-col>

                    <!-- Input di tipo testo: personaleMinisteroActiveData.persMinPrevRuolo  -->
                    <b-col xl="12" md="12" class="mb-2" v-show="!this.personaleMinisteroActiveData.persMinPrevPersonaleDiTerzi">
                      <label for="persMinPrevRuolo" class="h5">Ruolo</label>
                      <ejs-textbox id="persMinPrevRuolo" v-model="personaleMinisteroActiveData.persMinPrevRuolo" floatLabelType="Never"
                        cssClass="" placeholder="Ruolo" showClearButton="true" type="text" autocomplete="false" />
                    </b-col>





                  </b-row>
                </b-card-body>
              </b-card>
            </b-col>





          </b-row>
        </b-tab>



      </b-tabs>
    </ejs-dialog>




  </div>
</template>

<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'
// import bootstrap-Vue
import {
  LayoutPlugin, TabsPlugin, CardPlugin, DropdownPlugin, ImagePlugin, EmbedPlugin, TablePlugin, LinkPlugin, AlertPlugin, ProgressPlugin, ToastPlugin, FormGroupPlugin, FormInputPlugin, FormCheckboxPlugin, FormSelectPlugin, CarouselPlugin, FormRatingPlugin,
} from 'bootstrap-vue'
// import Vuexy
import AppTimeline from '@core/components/app-timeline/AppTimeline.vue'
import AppTimelineItem from '@core/components/app-timeline/AppTimelineItem.vue'
// import Syncfusion
import { enableRipple } from '@syncfusion/ej2-base'
import { Query } from '@syncfusion/ej2-data';
// import {
//   extend, addClass, createElement, isNullOrUndefined, detach, EventHandler,
// } from '@syncfusion/ej2-base'
import {
  DateTimePickerPlugin, DateRangePickerPlugin, DatePickerPlugin, TimePickerPlugin, CalendarPlugin
} from '@syncfusion/ej2-vue-calendars'
import { ButtonPlugin, CheckBoxPlugin, SwitchPlugin } from '@syncfusion/ej2-vue-buttons'
import {
  TextBoxPlugin, NumericTextBoxPlugin, MaskedTextBoxPlugin, SliderPlugin, UploaderPlugin,
} from '@syncfusion/ej2-vue-inputs'
import {
  DropDownListPlugin, MultiSelectPlugin, ListBoxPlugin, CheckBoxSelection,
} from '@syncfusion/ej2-vue-dropdowns'
import {
  RichTextEditorPlugin, Link, Image, Count, HtmlEditor, QuickToolbar, Toolbar as RTToolbar,
} from '@syncfusion/ej2-vue-richtexteditor' // rinominato Toolbar RTToolbar incomp con Word
import { SpreadsheetPlugin } from '@syncfusion/ej2-vue-spreadsheet'
import {
  SchedulePlugin, Day, Week, WorkWeek, Month, Agenda,
} from '@syncfusion/ej2-vue-schedule'
import { DocumentEditorContainerPlugin, DocumentEditorContainerComponentm, Toolbar } from '@syncfusion/ej2-vue-documenteditor'
import {
  PdfViewerPlugin, Magnification, Navigation, LinkAnnotation, BookmarkView, ThumbnailView, Print, TextSelection, TextSearch, Annotation, FormFields, FormDesigner, Toolbar as PDFToolbar,
} from '@syncfusion/ej2-vue-pdfviewer' // rinominato Toolbar PDFToolbar incomp con Word
import { KanbanPlugin } from '@syncfusion/ej2-vue-kanban'
import {
  GanttPlugin, Edit, Filter, Sort,
} from '@syncfusion/ej2-vue-gantt'
import { DiagramPlugin } from '@syncfusion/ej2-vue-diagrams'
import {
  MapsPlugin, Bubble, Zoom, MapsTooltip, Marker, NavigationLine,
} from '@syncfusion/ej2-vue-maps'
import { DialogPlugin } from '@syncfusion/ej2-vue-popups'
import {
  GridPlugin, Edit as GridEdit, Toolbar as GridToolbar, Sort as GridSort, Filter as GridFilter,
} from '@syncfusion/ej2-vue-grids'
import { DropDownButtonPlugin } from '@syncfusion/ej2-vue-splitbuttons'

const axios = require('axios')
// use bootstrap-vue
Vue.use(TabsPlugin)
Vue.use(CardPlugin)
Vue.use(LayoutPlugin)
Vue.use(DropdownPlugin)
Vue.use(ImagePlugin)
Vue.use(EmbedPlugin)
Vue.use(TablePlugin)
Vue.use(LinkPlugin)
Vue.use(AlertPlugin)
Vue.use(ProgressPlugin)
Vue.use(ToastPlugin)
Vue.use(FormGroupPlugin)
Vue.use(FormInputPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormSelectPlugin)
Vue.use(CarouselPlugin)
Vue.use(FormRatingPlugin)
// use Syncfusion
Vue.use(TextBoxPlugin)
Vue.use(NumericTextBoxPlugin)
Vue.use(MaskedTextBoxPlugin)
Vue.use(SliderPlugin)
Vue.use(UploaderPlugin)
Vue.use(DateRangePickerPlugin)
Vue.use(DatePickerPlugin)
Vue.use(DateTimePickerPlugin)
Vue.use(TimePickerPlugin)
Vue.use(DropDownListPlugin)
Vue.use(MultiSelectPlugin)
Vue.use(ButtonPlugin)
Vue.use(CheckBoxPlugin)
Vue.use(SwitchPlugin)
Vue.use(RichTextEditorPlugin)
Vue.use(SpreadsheetPlugin)
Vue.use(SchedulePlugin)
Vue.use(DocumentEditorContainerPlugin)
Vue.use(PdfViewerPlugin)
Vue.use(KanbanPlugin)
Vue.use(GanttPlugin)
Vue.use(DiagramPlugin)
Vue.use(MapsPlugin)
Vue.use(DialogPlugin)
Vue.use(GridPlugin)
Vue.use(DropDownButtonPlugin)
Vue.use(ListBoxPlugin)
enableRipple(true)
Vue.use(CalendarPlugin);
// api
const apiVueEndPoint = process.env.VUE_APP_API_ENDPOINT
//const apiPersonaleMinisteroUrl = '/demo/api/artista'
const apiPersonaleMinisteroUrl = '/demo/api/soggetto'

export default Vue.extend({
  components: {
  },
  data() {
    return {
      // per dropdownlist combinate
      stagioniData: [
        { StagioneName: 'Stagione 2022', StagioneId: '1' },
        { StagioneName: 'Stagione 2023', StagioneId: '2' }
      ],
      tipoRendData: [
        { TipologiaName: 'Preventivo', TipologiaId: '101' },
        { TipologiaName: 'Consuntivo', TipologiaId: '102' },
      ],
      stagioniFields: { value: 'StagioneId', text: 'StagioneName' },
      tipoRendFields: { value: 'TipologiaId', text: 'TipologiaName' },
      stagioniIndex: -1,
      tipoRendIndex: -1,
      tipoRendEnabled: false,
      stagioniQuery: null,
      tipoRendQuery: null,
      // generali
      settings: {
        formatoData: 'dd-MM-yyyy',
        formatoOra: 'HH:mm',
        intervalloOra: 15,
        listboxSelectionSettings: { showCheckbox: true },
      },
      // personale ministero
      personaleMinisteroFullData: [], // elenco completo dati produzioni
      personaleMinisteroActiveId: 0, // Id soggetto attivo (0 se nuovo)
      personaleMinisteroActiveData: {}, // dati completi dell soggetto attivo
      personaleMinisteroSavedData: {}, // dati completi dell soggetto attivo
      personaleMinisteroDefaultData: {}, // dati completi di default per nuovi produzioni
      personaleMinisteroNazionalitaList: [
        { label: 'Italiana o UE', id: 'ue' },
        { label: 'Extra UE', id: 'extra-ue' }], // elenco delle nazionalità 
      personaleMinisteroNazionalitaFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista della nazionalità
      personaleMinisteroINPSList: [
        { label: '011 artisti lirici', id: '011', cat: 'Gruppo canto', group: 'Raggruppamento A' },
        { label: '012 cantanti di musica leggera', id: '012', cat: 'Gruppo canto', group: 'Raggruppamento A' },
        { label: '013 coristi, vocalisti', id: '013', cat: 'Gruppo canto', group: 'Raggruppamento A' },
        { label: '014 maestri del coro, assistenti e aiuti del coro, suggeritori del coro', id: '014', cat: 'Gruppo canto', group: 'Raggruppamento A' },
        { label: '021 attori di prosa, mimi, allievi attori', id: '021', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '022 attori cinematografici o di audiovisivi', id: '022', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '023 attori di doppiaggio', id: '023', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '024 attori di operetta', id: '024', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '025 attori di rivista, attori di varietà ed attrazioni', id: '025', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '026 artisti del circo', id: '026', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '027 attori di fotoromanzi', id: '027', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '028 suggeritori teatrali, cinematografici o di audiovisivi', id: '028', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '029 generici, figuranti', id: '029', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '821 imitatori, ipnotizzatori, illusionisti e prestigiatori', id: '821', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '822 marionettisti, burattinai', id: '822', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '823 acrobati, stuntman, contorsionisti', id: '823', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: "824 maestri d'armi", id: '824', cat: 'Gruppo attori', group: 'Raggruppamento A' },
        { label: '031 presentatori', id: '031', cat: 'Gruppo conduttori e animatori', group: 'Raggruppamento A' },
        { label: '032 disc-jockey', id: '032', cat: 'Gruppo conduttori e animatori', group: 'Raggruppamento A' },
        { label: '033 animatori in strutture turistiche e di spettacolo', id: '033', cat: 'Gruppo conduttori e animatori', group: 'Raggruppamento A' },
        { label: '041 registi teatrali, cinematografici o di audiovisivi', id: '041', cat: 'Gruppo registi e sceneggiatori', group: 'Raggruppamento A' },
        { label: '042 aiuti registi teatrali, cinematografici o di audiovisivi', id: '042', cat: 'Gruppo registi e sceneggiatori', group: 'Raggruppamento A' },
        { label: '043 sceneggiatori teatrali, cinematografici o di audiovisivi', id: '043', cat: 'Gruppo registi e sceneggiatori', group: 'Raggruppamento A' },
        { label: '044 dialoghisti, adattatori cinetelevisivi o di audiovisivi', id: '044', cat: 'Gruppo registi e sceneggiatori', group: 'Raggruppamento A' },
        { label: '045 direttori della fotografia, light designer', id: '045', cat: 'Gruppo registi e sceneggiatori', group: 'Raggruppamento A' },
        { label: '046 soggettisti', id: '046', cat: 'Gruppo registi e sceneggiatori', group: 'Raggruppamento A' },
        { label: '047 video-assist', id: '047', cat: 'Gruppo registi e sceneggiatori', group: 'Raggruppamento A' },
        { label: '051 direttori di produzione', id: '051', cat: 'Gruppo produzione cinematografica, di audiovisivi e di spettacolo', group: 'Raggruppamento A' },
        { label: '052 ispettori di produzione', id: '052', cat: 'Gruppo produzione cinematografica, di audiovisivi e di spettacolo', group: 'Raggruppamento A' },
        { label: '053 segretari di produzione', id: '053', cat: 'Gruppo produzione cinematografica, di audiovisivi e di spettacolo', group: 'Raggruppamento A' },
        { label: '054 segretari di edizione', id: '054', cat: 'Gruppo produzione cinematografica, di audiovisivi e di spettacolo', group: 'Raggruppamento A' },
        { label: '055 cassieri di produzione', id: '055', cat: 'Gruppo produzione cinematografica, di audiovisivi e di spettacolo', group: 'Raggruppamento A' },
        { label: '056 organizzatori generali, location manager', id: '056', cat: 'Gruppo produzione cinematografica, di audiovisivi e di spettacolo', group: 'Raggruppamento A' },
        { label: '057 responsabili di edizione della produzione cinematografica e televisiva', id: '057', cat: 'Gruppo produzione cinematografica, di audiovisivi e di spettacolo', group: 'Raggruppamento A' },
        { label: '058 casting director', id: '058', cat: 'Gruppo produzione cinematografica, di audiovisivi e di spettacolo', group: 'Raggruppamento A' },
        { label: '059 documentalisti audiovisivi', id: '059', cat: 'Gruppo produzione cinematografica, di audiovisivi e di spettacolo', group: 'Raggruppamento A' },
        { label: '061 direttori di scena', id: '061', cat: 'Gruppo direttori di scena e di doppiaggio', group: 'Raggruppamento A' },
        { label: '062 direttori di doppiaggio', id: '062', cat: 'Gruppo direttori di scena e di doppiaggio', group: 'Raggruppamento A' },
        { label: '063 assistenti di scena e di doppiaggio', id: '063', cat: 'Gruppo direttori di scena e di doppiaggio', group: 'Raggruppamento A' },
        { label: "071 direttori d'orchestra", id: '071', cat: 'Gruppo direttori e maestri di orchestra', group: 'Raggruppamento A' },
        { label: "072 sostituti direttori d'orchestra", id: '072', cat: 'Gruppo direttori e maestri di orchestra', group: 'Raggruppamento A' },
        { label: '073 maestri collaboratori', id: '073', cat: 'Gruppo direttori e maestri di orchestra', group: 'Raggruppamento A' },
        { label: '074 maestri di banda', id: '074', cat: 'Gruppo direttori e maestri di orchestra', group: 'Raggruppamento A' },
        { label: '075 compositori', id: '075', cat: 'Gruppo direttori e maestri di orchestra', group: 'Raggruppamento A' },
        { label: '081 concertisti e solisti', id: '081', cat: 'Gruppo concertisti e orchestrali', group: 'Raggruppamento A' },
        { label: "082 professori d'orchestra", id: '082', cat: 'Gruppo concertisti e orchestrali', group: 'Raggruppamento A' },
        { label: '083 orchestrali (anche di musica leggera)', id: '083', cat: 'Gruppo concertisti e orchestrali', group: 'Raggruppamento A' },
        { label: '084 bandisti', id: '084', cat: 'Gruppo concertisti e orchestrali', group: 'Raggruppamento A' },
        { label: '085 consulenti assistenti musicali', id: '085', cat: 'Gruppo concertisti e orchestrali', group: 'Raggruppamento A' },
        { label: '091 coreografi e assistenti coreografi', id: '091', cat: 'Gruppo ballo figurazione e moda', group: 'Raggruppamento A' },
        { label: '092 ballerini e tersicorei', id: '092', cat: 'Gruppo ballo figurazione e moda', group: 'Raggruppamento A' },
        { label: '093 indossatori', id: '093', cat: 'Gruppo ballo figurazione e moda', group: 'Raggruppamento A' },
        { label: '094 figuranti lirici', id: '094', cat: 'Gruppo ballo figurazione e moda', group: 'Raggruppamento A' },
        { label: '095 figuranti di sala', id: '095', cat: 'Gruppo ballo figurazione e moda', group: 'Raggruppamento A' },
        { label: '096 fotomodelli', id: '096', cat: 'Gruppo ballo figurazione e moda', group: 'Raggruppamento A' },
        { label: '097 cubisti', id: '097', cat: 'Gruppo ballo figurazione e moda', group: 'Raggruppamento A' },
        { label: '098 spogliarellisti', id: '098', cat: 'Gruppo ballo figurazione e moda', group: 'Raggruppamento A' },
        { label: '101 amministratori di formazioni artistiche', id: '101', cat: 'Gruppo amministratori', group: 'Raggruppamento A' },
        { label: '102 amministratori di produzione cinematografica e audiovisiva', id: '102', cat: 'Gruppo amministratori', group: 'Raggruppamento A' },
        { label: '103 organizzatori teatrali', id: '103', cat: 'Gruppo amministratori', group: 'Raggruppamento A' },
        { label: '104 amministratori e segretari di compagnie teatrali', id: '104', cat: 'Gruppo amministratori', group: 'Raggruppamento A' },
        { label: '111 tecnici del montaggio, del suono e sound designer della produzione cinematografica', id: '111', cat: 'Gruppo tecnici', group: 'Raggruppamento A' },
        { label: '112 tecnici del montaggio, del suono e sound designer del teatro', id: '112', cat: 'Gruppo tecnici', group: 'Raggruppamento A' },
        { label: '113 tecnici del montaggio, del suono e sound designer di audiovisivi', id: '113', cat: 'Gruppo tecnici', group: 'Raggruppamento A' },
        { label: '114 tecnici del montaggio e del suono di altri settori dello spettacolo', id: '114', cat: 'Gruppo tecnici', group: 'Raggruppamento A' },
        { label: '115 tecnici di sviluppo, stampa, luci, scena, effetti speciali ed altri tecnici della produzione cinematografica', id: '115', cat: 'Gruppo tecnici', group: 'Raggruppamento A' },
        { label: '116 tecnici di luci, scena, effetti speciali ed altri tecnici del teatro', id: '116', cat: 'Gruppo tecnici', group: 'Raggruppamento A' },
        { label: '117 tecnici di sviluppo, stampa, luci, scena, effetti speciali ed altri tecnici di audiovisivi', id: '117', cat: 'Gruppo tecnici', group: 'Raggruppamento A' },
        { label: '118 tecnici di sviluppo, stampa, luci, scena, effetti speciali ed altri tecnici di fotoromanzi', id: '118', cat: 'Gruppo tecnici', group: 'Raggruppamento A' },
        { label: '119 tecnici addetti alle manifestazioni di moda', id: '119', cat: 'Gruppo tecnici', group: 'Raggruppamento A' },
        { label: '121 operatori di ripresa cinematografica o audiovisiva', id: '121', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento A' },
        { label: '122 aiuto operatori di ripresa cinematografica o audiovisiva', id: '122', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento A' },
        { label: '123 maestranze cinematografiche', id: '123', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento A' },
        { label: '124 maestranze teatrali', id: '124', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento A' },
        { label: '125 maestranze di imprese audiovisive', id: '125', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento A' },
        { label: '126 fotografi di scena', id: '126', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento A' },
        { label: '131 architetti, arredatori', id: '131', cat: 'Gruppi scenografi, arredatori e costumisti', group: 'Raggruppamento A' },
        { label: '132 costumisti, modisti, figurinisti e sarti teatrali, cinematografici o di audiovisivi', id: '132', cat: 'Gruppi scenografi, arredatori e costumisti', group: 'Raggruppamento A' },
        { label: '133 scenografi', id: '133', cat: 'Gruppi scenografi, arredatori e costumisti', group: 'Raggruppamento A' },
        { label: '134 bozzettista', id: '134', cat: 'Gruppi scenografi, arredatori e costumisti', group: 'Raggruppamento A' },
        { label: '135 story board artist', id: '135', cat: 'Gruppi scenografi, arredatori e costumisti', group: 'Raggruppamento A' },
        { label: "136 creatori di fumetti, illustrazioni e disegni finalizzati all'animazione", id: '136', cat: 'Gruppi scenografi, arredatori e costumisti', group: 'Raggruppamento A' },
        { label: '141 truccatori', id: '141', cat: 'Gruppo truccatori e parrucchieri', group: 'Raggruppamento A' },
        { label: '142 parrucchieri', id: '142', cat: 'Gruppo truccatori e parrucchieri', group: 'Raggruppamento A' },
        { label: '500 lavoratori autonomi esercenti attività musicali', id: '500', cat: 'Gruppo lavoratori autonomi esercenti attività musicali', group: 'Raggruppamento A' },
        { label: '154 artieri ippici', id: '154', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento B' },
        { label: '155 operatori di cabine di sale cinematografiche', id: '155', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento B' },
        { label: '156 maschere, custodi, guardarobieri, addetti alle pulizie e al facchinaggio', id: '156', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento B' },
        { label: '157 maschere, custodi, guardarobieri, addetti alle pulizie e al facchinaggio dipendenti dagli enti ed imprese esercenti pubblici spettacoli', id: '157', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento B' },
        { label: '158 maschere, custodi, guardarobieri, addetti alle pulizie e al facchinaggio dipendenti dalle imprese della produzione cinematografica, del doppiaggio e dello sviluppo e stampa', id: '158', cat: 'Gruppo operatori e maestranze', group: 'Raggruppamento B' },
        { label: '201 impiegati amministrativi e tecnici dipendenti dalle imprese radiofoniche, televisive o di audiovisivi', id: '201', cat: 'Gruppo impiegati', group: 'Raggruppamento B' },
        { label: '202 impiegati amministrativi e tecnici dipendenti dagli enti ed imprese esercenti pubblici spettacoli', id: '202', cat: 'Gruppo impiegati', group: 'Raggruppamento B' },
        { label: '203 impiegati amministrativi e tecnici dipendenti dalle imprese della produzione cinematografica, del doppiaggio e dello sviluppo e stampa', id: '203', cat: 'Gruppo impiegati', group: 'Raggruppamento B' },
        { label: '204 autisti dipendenti dagli enti ed imprese esercenti pubblici spettacoli, dalle imprese radiofoniche, televisive o di audiovisivi, dalle imprese della produzione cinematografica, del doppiaggio e dello sviluppo e stampa', id: '204', cat: 'Gruppo impiegati', group: 'Raggruppamento B' },
        { label: '205 operai dipendenti dagli enti ed imprese esercenti pubblici spettacoli, dalle imprese radiofoniche, televisive o di audiovisivi, dalle imprese della produzione cinematografica, del doppiaggio e dello sviluppo e stampa', id: '205', cat: 'Gruppo impiegati', group: 'Raggruppamento B' },
        { label: '211 impiegati dipendenti da ippodromi, scuderie di cavalli da corsa e cinodromi', id: '211', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '212 operai dipendenti da ippodromi, scuderie di cavalli da corsa e cinodromi', id: '212', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '213 impiegati dipendenti dalle imprese di spettacoli viaggianti', id: '213', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '214 operai dipendenti dalle imprese di spettacoli viaggianti', id: '214', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '217 impiegati dipendenti dalle case da gioco', id: '217', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '218 operai dipendenti dalle case da gioco', id: '218', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: "219 prestatori d'opera addetti ai totalizzatori o alla ricezione delle scommesse, presso gli ippodromi e cinodromi, nonché presso le sale da corsa e le agenzie ippiche", id: '219', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '235 impiegati dipendenti dalle sale scommesse', id: '235', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '236 operai dipendenti dalle sale scommesse', id: '236', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '237 impiegati dipendenti dalle sale giochi', id: '237', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '238 operai dipendenti dalle sale giochi', id: '238', cat: "Gruppo dipendenti imprese di spettacoli viaggianti..", group: 'Raggruppamento B' },
        { label: '215 impiegati dipendenti da impianti e circoli sportivi di qualsiasi genere, palestre, sale fitness, stadi, sferisteri, campi sportivi, autodromi', id: '215', cat: "Gruppo lavoratori degli impianti e circoli sportivi", group: 'Raggruppamento B' },
        { label: '216 operai dipendenti da impianti e circoli sportivi di qualsiasi genere, palestre, sale fitness, stadi, sferisteri, campi sportivi, autodromi', id: '216', cat: "Gruppo lavoratori degli impianti e circoli sportivi", group: 'Raggruppamento B' },
        { label: '771 istruttori presso impianti e circoli sportivi di qualsiasi genere, palestre, sale fitness, stadi, sferisteri, campi sportivi, autodromi', id: '771', cat: "Gruppo lavoratori degli impianti e circoli sportivi", group: 'Raggruppamento B' },
        { label: '772 addetti agli impianti e circoli sportivi di qualsiasi genere, palestre, sale fitness, stadi, sferisteri, campi sportivi, autodromi', id: '772', cat: "Gruppo lavoratori degli impianti e circoli sportivi", group: 'Raggruppamento B' },
        { label: '773 impiegati dipendenti da società sportive', id: '773', cat: "Gruppo lavoratori degli impianti e circoli sportivi", group: 'Raggruppamento B' },
        { label: '774 operai dipendenti da società sportive', id: '774', cat: "Gruppo lavoratori degli impianti e circoli sportivi", group: 'Raggruppamento B' },
        { label: '775 direttori tecnici presso società sportive', id: '775', cat: "Gruppo lavoratori degli impianti e circoli sportivi", group: 'Raggruppamento B' },
        { label: '776 massaggiatori presso società sportive', id: '776', cat: "Gruppo lavoratori degli impianti e circoli sportivi", group: 'Raggruppamento B' },
        { label: '777 istruttori presso società sportive', id: '777', cat: "Gruppo lavoratori degli impianti e circoli sportivi", group: 'Raggruppamento B' },
        { label: '231 impiegati dipendenti dalle imprese esercenti il noleggio e la distribuzione dei film', id: '231', cat: "Gruppo dipendenti da imprese di noleggio films", group: 'Raggruppamento B' },
        { label: '232 operai dipendenti dalle imprese esercenti il noleggio e la distribuzione dei film', id: '232', cat: "Gruppo dipendenti da imprese di noleggio films", group: 'Raggruppamento B' },
      ], // elenco codici INPS
      personaleMinisteroINPSFields: { groupBy: 'cat', text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista dei codici INPS
      personaleMinisteroINPSAllowFiltering: true,
      personaleMinisteroTipoPersonaleList: [
        { label: 'Amministrativo', id: 'amministrativo' },
        { label: 'Artistico', id: 'artistico' },
        { label: 'Artistico Lirico', id: 'artisticoLirico' },
        { label: 'Professore di orchestra', id: 'tecnico' },
        { label: 'Tecnico', id: 'tecnico' }], // elenco tipologia personale
      personaleMinisteroTipoPersonaleListFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista tipologia personale
      personaleMinisteroTipoRapportoList: [
        { label: 'Altro', id: 'altro' },
        { label: 'Coproduzione', id: 'coproduzione' },
        { label: 'Determinato', id: 'determinato' },
        { label: 'Indeterminato', id: 'indeterminato' },
        { label: 'Prestazione Occasionale', id: 'prestazioneOccasionale' }], // elenco tipologia rapporto
      personaleMinisteroTipoRapportoFields: { text: 'label', value: 'id' }, // specifica i campi da estrarre per popolare la lista tipologia rapporto
      personaleMinisteroDocFields: { text: 'persMinPrevNomeInLista', value: 'id' }, // specifica i campi da estrarre per popolare la lista dei documenti soggetto


      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA1
      dialogA1: {
        header: '',
        visible: false,
        showCloseIcon: true,
        buttons: [{ click: this.dialogA1Ok, buttonModel: { content: 'OK', isPrimary: true } },
        { click: this.dialogA1Cancel, buttonModel: { content: 'Cancel' } }],
        animationSettings: { effect: 'FadeZoom', duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogA1Index: 0,
      },
      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: true,
          allowDeleting: true,
        },
        filterOptions: { type: 'Excel' },
        toolbarOptions: [
          {
            text: 'Nuovo', tooltipText: 'Nuovo', prefixIcon: 'e-plus', id: 'new',
          },
          {
            text: 'Modifica', tooltipText: 'Modifica', prefixIcon: 'e-expand', id: 'edit',
          },
          {
            text: 'Cancella', tooltipText: 'Cancella', prefixIcon: 'e-cancel', id: 'delete',
          },
          'Search',
        ],
      }, //



    }
  },
  created() {
    // log
    console.log('Pagina Personale Ministero Creata')
    // inizializzazione elenchi dal backend
    // chiamate API


    // personaleMinisteroFullData
    // recupero elenco personaleMinistero dal backend
    // if (localStorage.getItem('userData') !== null) {
    //   console.log('Recupero elenco produzioni dal backend')
    //   useJwt.get(apiPersonaleMinisteroUrl).then(d => {
    //     console.log('produzioni')
    //     console.log(d.data)
    //     this.personaleMinisteroFullData = d.data
    //   })
    // } else {
    //   console.log('Non trovo UserData, prova ancora')
    // }

    // Recupero/definisco i valori di default delle entità utilizzate nel componente
    // personaleMinisteroDefaultData
    this.personaleMinisteroDefaultData = {
      id: 0,
      stagione: '',
      tipoRendicontazione: '',
      persMinPrevPersonaleDiTerzi: false,
      persMinPrevPersonaleStraniero: false,
      persMinPrevCodiceFiscale: '',
      persMinPrevNome: '',
      persMinPrevCognome: '',
      persMinPrevDataNascita: null,
      persMinPrevNazionalita: 'ue',
      persMinPrevCodiceINPS: null,
      persMinPrevTipoPersonale: null,
      persMinPrevTipoRapporto: null,
      persMinPrevRuolo: '',
      persMinPrevDataInizio: null,
      persMinPrevDataFine: null,
      persMinPrevGiornateLavorative: null,
      persMinPrevOneri: null,
      persMinPrevRetribuzione: false,
    }


  },
  mounted() {
    // disabilito gridA
    this.$refs.gridA.$el.classList.add('disablegrid')
    document.getElementById("GridParent").classList.add('wrapper')
    // focus su dropStagioni
    this.$refs.dropStagioni.ej2Instances.focusIn()
  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit],
    // per listBox
    listbox: [CheckBoxSelection],
  },
  methods: {
    // per elenco inps
    personaleMinisteroINPSFiltering: function (e) {
      var searchData = this.personaleMinisteroINPSList;
      var query = new Query();
      //frame the query based on search string with filter type.
      query = (e.text != "") ? query.where("label", "contains", e.text, true) : query; // puoi usare contains, startsWith, or endsWith
      //pass the filter data source, filter query to updateData method.
      e.updateData(searchData, query);
    },
    // per dropdownlist combinate
    onStagioneChange: function (e) {
      //this.tipoRendQuery = new Query().where('StagioneId', 'equal', this.$refs.dropStagioni.ej2Instances.value);
      this.tipoRendEnabled = true;
    },
    onTipoRendChange: function (e) {
      // abilito gridA
      this.$refs.gridA.$el.classList.remove('disablegrid');
      document.getElementById("GridParent").classList.remove('wrapper');
      // Inserire la chiamata per popolare la gridA
      // aggiungo provvisoriamente il popolamento di personaleMinisteroFullData (sostituire con chiamata API)
      this.personaleMinisteroFullData = [
        {
          id: 1,
          stagione: '2023',
          tipoRendicontazione: '',
          persMinPrevPersonaleDiTerzi: false,
          persMinPrevPersonaleStraniero: false,
          persMinPrevCodiceFiscale: '',
          persMinPrevNome: '',
          persMinPrevCognome: '',
          persMinPrevDataNascita: null,
          persMinPrevNazionalita: 'ue',
          persMinPrevCodiceINPS: null,
          persMinPrevTipoPersonale: null,
          persMinPrevTipoRapporto: null,
          persMinPrevRuolo: '',
          persMinPrevDataInizio: null,
          persMinPrevDataFine: null,
          persMinPrevGiornateLavorative: null,
          persMinPrevOneri: null,
          persMinPrevRetribuzione: false,
        },
        {
          id: 2,
          stagione: '2023',
          tipoRendicontazione: '',
          persMinPrevPersonaleDiTerzi: false,
          persMinPrevPersonaleStraniero: false,
          persMinPrevCodiceFiscale: '',
          persMinPrevNome: '',
          persMinPrevCognome: '',
          persMinPrevDataNascita: null,
          persMinPrevNazionalita: 'ue',
          persMinPrevCodiceINPS: null,
          persMinPrevTipoPersonale: null,
          persMinPrevTipoRapporto: null,
          persMinPrevRuolo: '',
          persMinPrevDataInizio: null,
          persMinPrevDataFine: null,
          persMinPrevGiornateLavorative: null,
          persMinPrevOneri: null,
          persMinPrevRetribuzione: false,
        },
        {
          id: 3,
          stagione: '2023',
          tipoRendicontazione: '',
          persMinPrevPersonaleDiTerzi: false,
          persMinPrevPersonaleStraniero: false,
          persMinPrevCodiceFiscale: '',
          persMinPrevNome: '',
          persMinPrevCognome: '',
          persMinPrevDataNascita: null,
          persMinPrevNazionalita: 'ue',
          persMinPrevCodiceINPS: null,
          persMinPrevTipoPersonale: null,
          persMinPrevTipoRapporto: null,
          persMinPrevRuolo: '',
          persMinPrevDataInizio: null,
          persMinPrevDataFine: null,
          persMinPrevGiornateLavorative: null,
          persMinPrevOneri: null,
          persMinPrevRetribuzione: false,
        },
      ]
    },

    // per dialogA1
    dialogA1OpenButtonClick() {
      this.$refs.dialogA1.show(true)
    },
    dialogA1Open() {
      console.log('Apertura dialogA1')
      // assegnare le informazioni da visualizzare nel dialog A
      console.log('Personale Ministero Attivo')
      console.log(this.personaleMinisteroActiveId)
      // // gestione docPersonaleMinisteroFullData
      // // recupero le informazioni pertinenti da docPersonaleMinisteroFullData
      // const list = this.docPersonaleMinisteroFullData // lista di origine
      // const ids = [this.personaleMinisteroActiveId] // ID soggetto da cercare nell'elenco info produzioni
      // const newArr = list.filter(item => ids.includes(item.artista)) // item.artista è dove cercare
      // // aggiorno personaleMinisteroActiveData.documenti
      // console.log('DOCUMENTI SOGGETTO CORRENTE')
      // this.personaleMinisteroActiveData.documenti = newArr
      // console.log(this.personaleMinisteroActiveData.documenti)

      this.personaleMinisteroSavedData = { ...this.personaleMinisteroActiveData }

      // this.imgPersonaleMinisteroActiveData = this.imgPersonaleMinisteroDefaultData
      // this.imgPersonaleMinisteroActiveId = 0
    },
    dialogA1Close() {
      console.log('Chiusura dialogA1')
      this.dialogA1.tabAdialogA1Index = 0
    },
    dialogA1Ok() {
      console.log('Cliccato bottone OK di dialogA1')
      // salvataggio informazioni in remoto
      if (this.personaleMinisteroActiveId === 0) {
        // salvataggio in caso di new
        useJwt.post(apiPersonaleMinisteroUrl, this.personaleMinisteroActiveData).then(res => {
          console.log(res.status)
          console.log(res.data)
          // mi segno ID elemento appena creato
          this.personaleMinisteroActiveId = res.data.id
          return this // restituisci contesto per permettere aggiornamento grid
        }).then(context => {
          useJwt.get(apiPersonaleMinisteroUrl).then(res => {
            console.log("Aggiornamento gridA con l'aggiunta di un soggetto")
            context.personaleMinisteroFullData = res.data
            context.personaleMinisteroFullData = [...context.personaleMinisteroFullData]
          })
        })
      } else {
        // salvataggio in caso di edit
        const editUrl = `${apiPersonaleMinisteroUrl}/${this.personaleMinisteroActiveId}`
        // qui devo fare caricamento dati ma non include i file da gestire con upload
        useJwt.patch(editUrl, this.personaleMinisteroActiveData).then(res => {
          console.log(res.status)
          return this // restituisci contesto per permettere aggiornamento gridA
        }).then(context => {
          useJwt.get(apiPersonaleMinisteroUrl).then(res => {
            console.log('Aggiornamento gridA con la modifica di un soggetto')
            context.personaleMinisteroFullData = res.data
            context.personaleMinisteroFullData = [...context.personaleMinisteroFullData]
          })
        })
      }
      this.$refs.dialogA1.hide()
      // triggerare aggiornamento filtering / ordinamento? <----------------------
    },
    dialogA1Cancel() {
      console.log('Cliccato bottone Cancel di dialogA1')
      this.$refs.dialogA1.hide()
    },
    // per gridA
    gridAClickHandler(args) {
      // pulsante NEW
      if (args.item.id === 'new') {
        this.dialogA1.header = 'Nuovo personale ministero'
        this.personaleMinisteroActiveData = this.personaleMinisteroDefaultData
        console.log('Premuto pulsante creazione nuovo personale ministero da gridA')
        // console.log(this.personaleMinisteroActiveData);
        // console.log(this.personaleMinisteroDefaultData);
        this.personaleMinisteroActiveId = 0
        this.$refs.dialogA1.show(true)
      }
      // pulsante EDIT 
      else if (args.item.id === 'edit') {
        this.dialogA1.header = 'Modifica Personale Ministero'
        console.log('Premuto pulsante modifica soggetto da gridA')
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          let found = false
          this.personaleMinisteroActiveId = selectedRow[0].id
          // console.log("gridA, Id selezionato:");
          console.log(this.personaleMinisteroActiveId)
          for (const i in this.personaleMinisteroFullData) {
            if (this.personaleMinisteroFullData[i].id === this.personaleMinisteroActiveId) {
              // console.log("id dell'elenco trovato:")
              // console.log('SOGGETTO CORRENTE')
              // console.log(this.personaleMinisteroFullData[i])
              this.personaleMinisteroActiveData = { ...this.personaleMinisteroFullData[i] }
              found = true
              break
            }
          }
          console.log('Personale Ministero Corrente')
          console.log(this.personaleMinisteroActiveData)
          console.log(this.personaleMinisteroActiveId)



          if (found) {
            // personale ministero
            console.log('Edit personale ministero')
            this.$refs.dialogA1.show(true)
          }
          else { console.log('Elemento non trovato') }
        } catch (err) {
          console.log('Occorre selezionare una riga della tabella')
          this.alertAShow()
        }
      }
      // Pulsante DELETE 
      else if (args.item.id === 'delete') {
        try {
          console.log('Premuto pulsante elimina personale ministero da gridA')
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          const deletedElementId = selectedRow[0].id

          const deleteUrl = `${apiPersonaleMinisteroUrl}/${deletedElementId}`
          this.$refs.gridA.ej2Instances.deleteRecord()

          useJwt.delete(deleteUrl).then(res => {
            console.log('Eliminazione avvenuta con successo')
            // console.log(res.data)
          })
        } catch (err) {
          // da sistemare..............
          console.log(err)
          console.log('Occorre selezionare una riga della tabella')
          this.alertAShow()
        }
      }
    },
    gridAactionBegin(e) {
      if (!this.gridAFlag) {
        // Add and edit operations
        if (e.requestType === 'save') {
          const editedData = e.data
          console.log(editedData)
          // The default edit operation is cancelled
          e.cancel = true
          const editUrl = `${apiPersonaleMinisteroUrl}/${editedData.id}`
          useJwt.patch(editUrl, editedData).then(res => {
            console.log(res)
            if (res.status === 200) {
              // se tutto OK
              // Flag is enabled to skip this execution when grid ends add/edit
              this.gridAFlag = true
              // If your data is updated at the server side successfully, we can call the grid endEdit() method to save the edited data to the Grid
              this.$refs.gridA.endEdit()
            } else {
              this.makeToast('primary', 'Attenzione', 'Salvataggio soggetto non riuscito')
            }
          })
        }
      }
    },
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridAactionComplete(e) {
      if (e.requestType === 'save') {
        // The flag is disabled after operation is successfully performed so that it can enter the condition on next execution
        this.gridAFlag = false
      }
    },

    // per click tabs
    tabClicked(args) {
      switch (args) {
        case 'dialogA1Tab01':
          console.log('Sei nel primo tab del dialogA1')
          break
        case 'dialogA1Tab02':
          console.log('Sei nel secondo tab del dialogA1')
          break
        default:
          console.log(args)
      }
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs
    },
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      })
    },

  },
  computed: {
    hasChanged() {
      // console.log(this.personaleMinisteroActiveData)
      // console.log(this.personaleMinisteroSavedData)
      return Object.keys(this.personaleMinisteroActiveData).some(field => this.personaleMinisteroActiveData[field] !== this.personaleMinisteroSavedData[field])
    },
  },
})

/* eslint-disable global-require */
</script>

<style lang="scss" >
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import '~@syncfusion/ej2-calendars/styles/material.css';
@import '~@syncfusion/ej2-calendars/styles/datepicker/material.css';
@import '~@syncfusion/ej2-dropdowns/styles/material.css';
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import '~@syncfusion/ej2-inputs/styles/material.css';
@import '~@syncfusion/ej2-vue-layouts/styles/material.css';
@import '~@syncfusion/ej2-vue-richtexteditor/styles/material.css';
@import '~@syncfusion/ej2-splitbuttons/styles/material.css';
@import '~@syncfusion/ej2-grids/styles/material.css';
@import "~@syncfusion/ej2-vue-spreadsheet/styles/material.css";
@import '~@syncfusion/ej2-schedule/styles/material.css';
@import "~@syncfusion/ej2-vue-documenteditor/styles/material.css";
@import "~@syncfusion/ej2-treegrid/styles/material.css";
@import "~@syncfusion/ej2-vue-gantt/styles/material.css";
@import "~@syncfusion/ej2-vue-diagrams/styles/material.css";
@import "~@syncfusion/ej2-vue-kanban/styles/bootstrap.css";

.e-btn-icon.e-open-icon {
  background: url('~@/assets/images/svg/open2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url('~@/assets/images/svg/garbage-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url('~@/assets/images/svg/download2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url('~@/assets/images/svg/search-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url('~@/assets/images/svg/upload-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url('~@/assets/images/svg/add2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}

// per colorare placeholder dropdownlist
//.e-ddl.e-input-group input.e-input::placeholder {
//    color: rgb(199, 113, 113);
//}

</style>
